import zipCbsaData from "./data/zip-cbsa.json";

interface ZipLookup {
  cbsa: string;
  state: string;
}

const zipData = zipCbsaData as Record<string, ZipLookup>;

/**
 * Resolve a U.S. ZIP code to its state name.
 * Returns null if the ZIP is not found.
 */
export function lookupStateFromZip(zipCode: string): string | null {
  const padded = zipCode.padStart(5, "0");
  const entry = zipData[padded];
  return entry?.state ?? null;
}
